const { ccclass, property } = cc._decorator;
import ViewBase from "../../../../framework/core/mvvm/view_base";
import TablePlayerAvatar from "../../components/table_player_avatar";

@ccclass
export default abstract class TableBaseView extends ViewBase {
   
    @property(cc.Prefab)
    prefabAvatar: cc.Prefab = null


    protected m_avatar_pool: cc.NodePool = new cc.NodePool()
    protected m_id2Avata_map = {}
    protected m_pos2Avata_map = {}

    protected genAvatar(){
        if(this.m_avatar_pool.size() > 0){
            return this.m_avatar_pool.get().getComponent(TablePlayerAvatar)
        }
        let avatar = cc.instantiate(this.prefabAvatar).getComponent(TablePlayerAvatar)
        avatar.setClickAvatarBtnListener((a)=>{
            this.eventDispatch('on_click_player_avatar', a)
        })
        return avatar
    }

    protected collectAvatar(avatar: TablePlayerAvatar){
        if(avatar){
            avatar.show(false)
            avatar.reset()
            this.m_avatar_pool.put(avatar.node)
        }        
    }

    getAvatarById(id: number): TablePlayerAvatar{
        return this.m_id2Avata_map[id]
    }

    addAvatarById(id: number, playerId: number, parent: cc.Node){
        let avatar = this.getAvatarById(id)
        if(avatar){
            throw `already exist avatar which id is ${id}`;            
        }
        avatar = this.genAvatar()
        avatar.node.parent = parent
        avatar.node.position = cc.Vec3.ZERO
        this._addAvatar2Map(avatar, id)
        avatar.show(true, playerId)
        return avatar
    }

    removeAvatarById(id: number){
        this.collectAvatar(this.m_id2Avata_map[id])
        delete this.m_id2Avata_map[id]
    }

    removeAllAvatars(){
        for (const key in this.m_id2Avata_map) {
            if (this.m_id2Avata_map.hasOwnProperty(key)) {
                this.collectAvatar(this.m_id2Avata_map[key])
            }
        }
        this.m_id2Avata_map = {}
    }

    protected _addAvatar2Map(avatar, id){
        this.m_id2Avata_map[id] = avatar
    }

}